// client/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { DivesitesContextProvider } from "./contexts/divesiteContext.js";
import { ThemeContextProvider } from "./theme"; // Corrected path to your ThemeContextProvider

// *** IMPORT THESE TWO LINES ***
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
// ****************************

// *** CREATE THE EMOTION CACHE INSTANCE ***
const emotionCache = createCache({
  key: "mui", // A unique key for your cache. 'mui' is common.
  // prepend: true, // Optional: Use this if you want Material-UI's styles to be injected first in the <head>
  // This can help ensure your custom styles override MUI's defaults if they appear later.
});
// *****************************************

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {" "}
    {/* React.StrictMode is good practice for development */}
    {/* *** WRAP YOUR ENTIRE APP WITH CacheProvider *** */}
    <CacheProvider value={emotionCache}>
      <ThemeContextProvider>
        <AuthProvider>
          <DivesitesContextProvider>
            <App />
          </DivesitesContextProvider>
        </AuthProvider>
      </ThemeContextProvider>
    </CacheProvider>
    {/* *********************************************** */}
  </React.StrictMode>
);
